import axios from "axios"

//const URL = "http://localhost:8889/api"
const URL = "https://parkmountschool.com/api/"

const api = axios.create({
    baseURL: URL
})

export function setAuthToken(token) {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`
    } else {
        delete api.defaults.headers.common["Authorization"]
    }
}

export default api